<template>
    <div v-loading="loading" class="individualCallSplit" id="individualCallSplit">
        <div v-if="isEmployeeAllowed">
            <div 
                ref="scrollContainer"
                class="o-ndividualArea c-responsive-fixwidth" 
                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                style="min-height: 1px;" 
                infinite-scroll-disabled="busy" 
                infinite-scroll-distance="10"
            >
                <div v-if="isNonEmpty">
                    <div v-for="(dateWiseCalls, key, index) in calls" :key="key">
                        <div v-if="(key!='' && dateWiseCalls.length > 0)" class="o-ndividualTable">
                            <div class="c-common-space o-individual-calls">
                                <div class="col-md-12 o-no-padding">
                                    <h5 :id="'element'+index" class="h5 o-inline">
                                        <div class="calls-table-cell" style="display:inline-block; vertical-align:middle;">
                                            <div class="o-no-padding">
                                            <div class="calls-table-cell-inner-table">
                                                <div class="checkbox o-custom-radio">
                                                <label>
                                                    <!-- <input @change="updateQueueSelectionDate(call)" type="checkbox" name="'check'+key" :value="auto_fill" v-model="auto_fill"> -->
                                                    <input
                                                        type="checkbox"
                                                        :name="'check-' + key"
                                                        :value="key"
                                                        v-model="dateGroupAutofill[key]"
                                                        :indeterminate="dateGroupIndeterminate(key)"
                                                        @change="handleGroupAutofillChange(key, $event.target.checked)"
                                                    />
                                                    <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                </label>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        <i class="fa fa-calendar-o" aria-hidden="true"></i>
                                        {{getDate(key)}}
                                    </h5>
                                    <a href="javascript: void(0)" :class="{'isDisabled':!getPower('cloneCall')}" @click="openCloneModal(key)" class="c-common-btn c-common-btn--small"><i class="fa fa-files-o" aria-hidden="true"></i> Clone</a>
                                    <a @click="openAdvanceClone(key)" :class="{'isDisabled':!getPower('cloneCall')}" class="c-common-btn c-common-btn--small"><i class="fa fa-files-o" aria-hidden="true"></i> Advance Clone</a>
                                    <a :class="{'isDisabled':!getPower('deleteCall')}" href="javascript: void(0)" @click="deleteCallsByDate(dateWiseCalls)" class="c-common-btn c-common-btn--small">
                                        <i class="fa fa-trash-o" aria-hidden="true"></i> 
                                        Delete Day
                                    </a>

                                    <div class="o-customSelect o-custom-dropdown o-inline-block margin-left-md">
                                        <label>Jump to day:</label>
                                        <select @change="onSelectScrollTo($event)" class="form-control">
                                            <option v-for="(call, key, index) in calls" :key="index" v-if="call.length>0" :value="'#element'+index" >{{getDateScrollTO(key)}}</option>
                                        </select>
                                        <span class="o-custom-drop-arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></span>
                                    </div>

                                    <div class="o-customSelect o-custom-dropdown o-inline-block margin-left-md">
                                        <label>Sort by:</label>
                                        <select v-model="selectedSortType" class="form-control" @change="changeSortType">
                                            <option value="status">Unassigned</option>
                                            <option value="start">Start time</option>
                                            <option value="skill">Skill</option>
                                            <option value="seniority">Seniority</option>
                                        </select>
                                        <span class="o-custom-drop-arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></span>
                                    </div>

                                    <div class="custom-col text-right float-right">
                                        <a  href="javascript: void(0)" v-if="isEmployeeAllowed&&(getPower('addCall') || addCallPower())" @click="addBulkCall(key)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Calls</a>
                                    </div>

                                </div>
                            </div>

                            <table class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 payroll-viewcall-table-align overflow-show">
                                <thead>
                                    <tr>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">AF</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">Start time:</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right"><span class="o-no-margin-bottom">End time:</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">Position</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right"><span class="o-no-margin-bottom">Employee</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext text-center"></th>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right text-center"><span class="o-no-margin-bottom">Rate/hr.</span></th>
                                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right text-center"><span class="o-no-margin-bottom">Notes</span></th>
                                        <th align="center" valign="top" class="o-accordion-subtext"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(call, id) in dateWiseCalls" :key="id">
                                        <td align="left" valign="top" class="table-td-border-top">
                                            <div class="">
                                                <div class="o-no-padding">
                                                    <div class="">
                                                        <div class="checkbox">
                                                            <label>
                                                                <input 
                                                                    @change="handleIndividualAutofillChange(call)" 
                                                                    type="checkbox" 
                                                                    name="'check'+key" 
                                                                    :value="call.id" 
                                                                    v-model="call.af"
                                                                />
                                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        <td :id="'backTo'+index+id" :ref="'backTo'+index+id" align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                            <p>{{getTime(call.start)}}</p>
                                        </td>
                                        <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 table-td-border-right">
                                            <p>{{getTime(call.end)}}</p>
                                        </td>
                                        <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                            <p>{{call.skill.name+'('+call.skill.priotiy+')'}}</p>
                                        </td>
                                        <!-- #1511 — double-click an empty Employee cell to onboard a new
                                             worker straight into this slot (seats them Unconfirmed + texts the
                                             link). Gated to steward / PU / CA / SA, enforced server-side. -->
                                        <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 table-td-border-right" @dblclick="maybeOnboard(call)">
                                            <p v-if="(call.employee != null)" :class="{'text-danger':call.employee.deleted_at}">
                                                <span v-if="call.employee&&call.employee.employable">
                                                    {{call.employee.employable.first_name+" "+call.employee.employable.last_name}}{{call.employee.seniority?"("+getRoundOffSkillSeniority(call.employee.seniority)+")":''}}
                                                    <el-tooltip class="item" effect="dark" content="Confirmed" placement="top-end">
                                                        <i v-if="call.status&&call.status.name&&call.status.name=='Confirmed'" aria-hidden="true" class="fa fa-check confirm-check-icon-style el-tooltip item" aria-describedby="el-tooltip-5474" tabindex="0"></i>
                                                    </el-tooltip>
                                                </span>
                                            </p>
                                            <p v-else :class="{'onboard-dblclick-hint': canOnboard}" :title="canOnboard ? 'Double-click to onboard a new worker into this slot' : ''">- - -</p>
                                        </td>
                                        <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 text-center">
                                        <p v-if="call.status&&call.status.name&&call.status.name=='Unassigned'"><a @click="singleAssign(call,'backTo'+index+id)" href="javascript: void(0)" class="c-common-btn c-common-btn--xsmall c-common-btn--inverse-icon-green c-common-btn-min-width"><i data-v-d8a8ddae="" aria-hidden="true" class="fa fa-plus-circle"></i>
                                            Assign
                                        </a></p>
                                        <p v-if="call.status&&call.status.name&&call.status.name!='Unassigned'"><a  @click="cleaeAssign(call,'backTo'+index+id)" :class="{'disabled isDisabled':!getPower('clearAssign')}" href="javascript: void(0)" class="c-common-btn c-common-btn--xsmall c-common-btn--inverse-icon clear-button c-common-btn-min-width">
                                            <i aria-hidden="true" class="fa fa-minus-circle"></i>
                                            Clear Assign
                                        </a></p>
                                        </td>
                                        <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5  text-center table-td-border-right">
                                            <p  v-if="call.rate"><label v-html="getCurrencyIcon()"></label>{{call.rate}}</p>
                                            <p  v-else>- - -</p>
                                        </td>
                                        <td align="center" valign="top" class="o-rowtable-text-td table-td-border-top table-td-border-right u-cmn-padding10">
                                            <div v-if="call.notes && call.notes.length>40" :class="{'o-green-icon o-tooltip-trigger':call.notes, 'notify-icon':true}">
                                                {{getNotes(call.notes)}}
                                                <i aria-hidden="true" class="fa fa-exclamation-circle"></i>
                                                <div class="tooltip c-common-box-shadow">
                                                    {{call.notes && call.notes.length>0 ? call.notes:'- - -'}}
                                                </div>
                                            </div>
                                            <p v-else>{{call.notes && call.notes.length>0 ? call.notes:'- - -'}}</p>
                                        </td>
                                        <td align="center" valign="top" class="o-table-block-btn o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                        <div class="fontsize-0">
                                            <a :class="{'disabled':!getPower('splitCall')}" href="javascript: void(0)" @click="openSplitCall(call)" v-if="call.status&&call.status.name&&call.status.name=='Confirmed' && call.split_flag == 0" class="float-none edit-del"><i aria-hidden="true" class="fa fa-cutlery"></i></a>
                                            <a :class="{'disabled':!getPower('editCall')}" @click="editCalls(call,'backTo'+index+id)" href="javascript: void(0)" class="float-none edit-del"><i aria-hidden="true" class="fa fa-pencil"></i></a>
                                            <a :class="{'disabled':!getPower('deleteCall')}" @click="deleteCall(call,'backTo'+index+id)" href="javascript: void(0)" class="float-none edit-del"><i  aria-hidden="true" class="fa fa-trash-o"></i></a>
                                        </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="c-common-gradient c-common-box-shadow c-radius3">
                        <div class="col-md-12 no-job-dispaly">
                        <i class="fa fa-frown-o" aria-hidden="true"></i>
                        <br />
                            No Data Stored
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <NotAllowed />
        </div>
        <modal name="edit-call"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
          <div id="" class="modal-add-call" tabindex="-1" role="dialog">
             <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center modal-header--heading">
                        <button type="button"  @click="closeEditCalls()" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                        <h1 class="modal-title">Edit Call</h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="common-label-text">Start Time:</label>
                                    <date-picker name="start" v-validate="{required: true}" v-model="editCallData.start" :config="config"></date-picker>
                                    <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="common-label-text">End Time:</label>
                                    <div>
                                        <date-picker name="start" v-validate="{required: true}" v-model="editCallData.end" :config="config"></date-picker>
                                        <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text--fullwidth">Position:</label>
                                    <div class="o-cutsomSelect">
                                      <select class="form-control"  v-model="editCallData.skill_id">
                                        <option v-for="(position,posIndex) in positions" :value="position.id" :key="posIndex">{{position.name}}</option>
                                      </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="common-label-text">Rate(<span v-html="getCurrencyIcon()"></span>):</label>
                                    <div>
                                        <input v-model="editCallData.rate" type="text" class="form-control u-border-radius-0" :placeholder="getCurrencyUpper()">
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="common-label-text">Status:</label>
                                    <div>
                                        <input type="text" :value="status" class="form-control" placeholder="01:59 AM" disabled>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label class="common-label-text common-label-text--fullwidth">Notes:</label>
                                    <div class="">
                                        <textarea v-model="editCallData.notes" class="form-control" rows="3" placeholder="Notes"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12 o-modal-field-area">
                                <span class="col-sm-6 o-right-no-padding o-modal-form-field allign-right">
                                    <label class="common-label-text common-label-text--modalwidth">Keep Confirmations:</label>
                                </span>
                                <el-switch
                                    style="display: inline"
                                    v-model="editCallData.keep_confirmation"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6"
                                    active-value=1
                                    inactive-value=0>
                                </el-switch>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeEditCalls()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="saveEditCall()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-pencil" aria-hidden="true"></i> Edit Call</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
          </div>
        </modal>

        <modal name="split-call"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
          <div id="" class="modal-add-call" tabindex="-1" role="dialog">
             <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center modal-header--heading">
                        <button type="button"  @click="hideSplitCall()" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                        <h1 class="modal-title">Split Call</h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="call-timings-text">
                                    <label class="common-label-text">From:</label>

                                    <p class="mt-10">{{ getFormattedCallTime() }}</p>
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="form-group ">
                                    <label class="common-label-text mb-5p">End Time:</label>
                                    <div>
                                        <date-picker name="start" v-validate="{required: true}" v-model="splitCallData.end" :config="config" placeholder="Select Time"></date-picker>
                                         <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-8">
                                <div class="form-group">
                                    <label class="common-label-text mb-5p">Break Duration:</label>
                                    <div>
                                        <date-picker
                                            name="break"
                                            placeholder="Select Duration"
                                            v-model="splitCallData.break"
                                            :config="config2">
                                        </date-picker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="hideSplitCall()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="saveSplitCall()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-cutlery" aria-hidden="true"></i> Split Call</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
          </div>
        </modal>

        <modal name="call-clone"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
          <div id="" class="modal-add-call" tabindex="-1" role="dialog">
             <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center modal-header--heading">
                        <button @click="closeCloneModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                        <h1 class="modal-title">Basic Clone</h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <h2 class="h2 text-center">{{selectedJobTitle}}</h2>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <hr class="o-modal-separetor" />
                                    </div>
                                </div>
                                <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                    <p class="ps2">This routine will duplicate all calls from the source date to another day within the same job. All calls already existing in that day will be deleted, so this tool should be used before adding additional calls that are not sourced from the original date.</p>
                                    <p class="ps2">To clone days to a date outside of the job's scope, it will be necessary to edit the job and extend the end date, otherwise the date will not appear in the dropdown box.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <hr class="o-modal-separetor" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="common-label-text">Clone
                                        <br />calls from:</label>
                                    <label class="common-label-input">
                                        {{getGlobalDate(cloneData.cloneFrom)}}
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group ">
                                    <label class="common-label-text">Clone
                                        <br />calls to:</label>
                                    <label class="common-label-input">
                                        <div class="o-cutsomSelect">
                                            <select class="form-control" v-model="cloneData.closeTo">

                                                <option v-for="(callDay, key) in callDaysForJob" :value="callDay.date" :key="key">{{getGlobalDate(callDay.date)}}</option>
                                            </select>
                                        </div>
                                    </label>
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="form-group ">
                                    <label class="common-label-text">Copy assignments?</label>
                                    <div class="checkbox o-custom-radio">
                                        <label>
                                            <input type="checkbox" id="checkbox" v-model="cloneData.assignments">
                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeCloneModal()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="cloneCall()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Calls</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
          </div>
        </modal>

        <modal name="advance-call-clone"  height="auto" width="1000px" :scrollable="true" class="modal-xl o-large-modal">
          <div id="" tabindex="-1" role="dialog">
              <div role="document">
                  <div class="modal-content o-common-modal-content">
                      <div class="modal-header u-no-border text-center modal-header--heading">
                          <button @click="closeAdvanceClone()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                          <h1 class="modal-title">Advance Bulk Clone Call</h1>
                      </div>

                      <div class="c-common-box-shadow o-modal-body c-margin-bottom-10">
                        <div class="row">
                          <div class="col-sm-6">
                                <div class="form-group o-no-margin">
                                    <label class="common-label-text">Clone From:</label>
                                    <label class="common-label-input">
                                      <div class="o-cutsomSelect">
                                          <select class="form-control" v-model="advanceCloneData.callUnderSelectedDay">
                                              <option v-for="(callDay, key) in callDaysForJob" :key="key" :value="callDay.calls" v-if="(callDay.calls.length>0)? true : false" v-bind:selected="key === 0">{{getGlobalDate(callDay.date)}}</option>
                                          </select>
                                      </div>
                                    </label>
                                </div>
                          </div>
                          <div class="col-sm-6">
                              <div class="form-group o-no-margin">
                                  <label class="common-label-text">Insert Mode:</label>
                                  <label class="common-label-input">
                                    <div class="o-cutsomSelect">
                                        <select class="form-control" v-model="advanceCloneData.insertMode">
                                            <option value="1">Merge calls into existing calls</option>
                                            <option value="0">Replace all existing calls</option>

                                        </select>
                                    </div>
                                  </label>
                              </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-md-6">
                          <div class="c-common-box-shadow c-bg-white c-margin-bottom-10">
                              <div class="row">
                                  <div class="col-md-12">
                                      <div class="call-clone-table o-table-overflow-large">
                                          <div class="call-clone-table-head">
                                              <h4 class="ps1">Clone From</h4>
                                              <div class="o-floar-right">
                                                  <h4 class="ps2 o-blue-medium-text">   :</h4>
                                                  <a href="javascript: void(0)" @click="selectAllCall()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilter == 'all')?'o-filter-active':''">All</a>
                                                  <a href="javascript: void(0)" @click="selectNoneAllCall()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilter == 'none')?'o-filter-active':''">None</a>
                                              </div>
                                          </div>
                                          <div class="call-clone-table-body">
                                              <div class="call-clone-table-body-tr">
                                                  <div class="call-clone-table-body-tr-td">
                                                      &nbsp;
                                                  </div>
                                                  <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                      Start time
                                                  </div>
                                                  <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                      End time
                                                  </div>
                                                  <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                      Skill
                                                  </div>
                                                  <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                      Employee
                                                  </div>
                                              </div>
                                              <div v-for="(call,calIndex) in advanceCloneData.callUnderSelectedDay" :key="calIndex" class="call-clone-table-body-tr">
                                                  <div class="call-clone-table-body-tr-td">
                                                      <div class="checkbox o-custom-radio">
                                                          <label>
                                                              <input type="checkbox" name="o4" :value="call.id" v-model="advanceCloneData.selectedcallsToClone">
                                                              <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                          </label>
                                                      </div>
                                                  </div>
                                                  <div class="call-clone-table-body-tr-td">
                                                      {{getTime(call.start)}}
                                                  </div>
                                                  <div class="call-clone-table-body-tr-td">
                                                      {{getTime(call.end)}}
                                                  </div>
                                                  <div class="call-clone-table-body-tr-td">
                                                      {{call.skill.name}}
                                                  </div>
                                                  <div class="call-clone-table-body-tr-td">
                                                      {{(call.employee != null)?call.employee.employable.first_name + " " + call.employee.employable.last_name:"Not Assign"}}
                                                  </div>
                                              </div>

                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="c-common-box-shadow c-bg-white c-margin-bottom-5">
                              <div class="row">
                                  <div class="col-sm-12">
                                      <div class="call-clone-table-head">
                                          <div class="form-group o-no-margin">
                                              <label class="common-label-text common-label-text--fullwidth">Assignments:</label>
                                              <label class="common-label-input--fullwidth o-custom-dropdown">
                                                  <select class="form-control" v-model="advanceCloneData.assignments">
                                                      <option value="1">Preserve call assignments</option>
                                                      <option value="0">Clear call assignments</option>
                                                  </select>
                                                  <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                              </label>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-sm-12">
                                      <div class="call-clone-table-head">
                                          <hr class="o-common-separetor o-no-margin" />
                                      </div>
                                  </div>
                                  <div class="col-md-12">
                                      <div class="call-clone-table o-table-overflow-large">
                                          <div class="call-clone-table-head">
                                              <div class="o-floar-left clone-to-box-inline" style="width: 65%; display: inline-block;">
                                                  <h4 class="ps2 o-blue-medium-text">Clone To:</h4>
                                                  <select class="form-control clone-to-select-box" v-model="advanceCloneData.selectedCloneToJob" @change="getJobCalls()" style="width: 70%; display: inline-block;">
                                                      <option v-for="(job,jobIdx) in avdCloneJob" :key="jobIdx" :value="job.id">{{job.title}}</option>

                                                  </select>
                                              </div>
                                              <div class="o-floar-right">
                                                  <h4 class="ps2 o-blue-medium-text">Select:</h4>
                                                  <a href="javascript: void(0)" @click="selectAllDay()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilterDay == 'allDay')?'o-filter-active':''">All</a>
                                                  <a href="javascript: void(0)" @click="selectNoneAllDay()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilterDay == 'noneDay')?'o-filter-active':''">None</a>
                                              </div>

                                          </div>
                                          <div class="call-clone-table-body">
                                              <div class="call-clone-table-body-tr">
                                                  <div class="call-clone-table-body-tr-td">
                                                      &nbsp;
                                                  </div>
                                                  <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                      Date
                                                  </div>
                                                  <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                      Calls
                                                  </div>

                                              </div>
                                              <div v-for="(dayCall,dayCalIdx) in avdCloneCall" :key="dayCalIdx" class="call-clone-table-body-tr">
                                                  <div class="call-clone-table-body-tr-td">
                                                      <div class="checkbox o-custom-radio">
                                                          <label>
                                                              <input type="checkbox" name="o4" :value="dayCall.date" v-model="advanceCloneData.selectedDaysToClone">
                                                              <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                          </label>
                                                      </div>
                                                  </div>
                                                  <div class="call-clone-table-body-tr-td">
                                                    {{getGlobalDate(dayCall.date)}}
                                                  </div>
                                                  <div class="call-clone-table-body-tr-td">
                                                      {{dayCall.calls}} calls
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                        </div>

                      </div>

                      <div class="modal-footer text-center">
                          <ul class="o-filter-area">
                              <li>
                                  <a href="javascript: void(0)" @click="closeAdvanceClone()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                              </li>
                              <li>
                                  <a href="javascript: void(0)" @click="saveAdvanceClone()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Clone Calls</a>
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>
          </div>
        </modal>

        <modal name="clone-conflict-employee-modal"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
          <div id="" class="modal-add-call" tabindex="-1" role="dialog">
             <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center modal-header--heading">
                        <button @click="closeCloneConflictEmployeeModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                        <h1 class="modal-title">
                            Clone Assignment Conflict
                            <el-tooltip class="item" effect="dark" content="Click to Copy Job Data" placement="top-start">
                                <a @click.stop="copyText()" class="o-job-copy-icon"><i class="fa fa-paste"></i></a>
                            </el-tooltip>
                        </h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                    <div class="ps2">
                                        Following employees will not get assignments due to conflict of assignment.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <hr class="o-modal-separetor" />
                            </div>
                        </div>
                        <div v-for="(emp,index) in cloneConflictEmployees" :key="index">
                            <p class="ps2">
                                {{ index+1 +'. ' + emp.emp_name }} has a conflict because of
                                <span v-if="emp.conflict_type=='Recurring Unavailability'" class="text-danger">
                                    Recurring Unavailability
                                </span>
                                <span v-else-if="emp.conflict_type=='Vacation' && emp.job_no==''" class="text-warning">
                                    Vacation
                                </span>
                                <span v-else-if="emp.conflict_type=='booking' && emp.job_no!=''" class="text-primary">
                                    {{ emp.job_title + ' - (' + emp.job_no + ')' }}
                                </span>
                                <span v-else class="text-info">{{ emp.conflict_type }}</span>
                            </p>
                        </div>
                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <vue-json-to-csv :json-data="cloneConflictEmployees"
                                    :labels="{
                                        emp_name: { title: 'Name' },
                                        date: { title: 'Date' },
                                        conflict_type: { title: 'Conflict'},
                                        job_title: { title: 'Job Name' },
                                        job_no: { title: 'Job Number' },
                                    }"
                                    @success="val => handleCsvSuccess(val)"
                                    @error="val => handleCsvError(val)"
                                    csv-title="Clone-Conflict-Employee"
                                    >
                                    <el-tooltip class="item" effect="dark" content="Click to Download CSV" placement="top-start">
                                        <a href="javascript: void(0)"  class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue">Download To CSV <i class="fa fa-arrow-circle-o-down"></i></a>
                                    </el-tooltip>
                                </vue-json-to-csv>
                            </li>

                            <li>
                                <a href="javascript: void(0)" @click="closeCloneConflictEmployeeModal()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"> Close </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
          </div>
        </modal>

        <!-- #1511 — Onboard a new worker straight onto a blank call slot. -->
        <modal name="onboard-slot" height="auto" :scrollable="true" class="modal-dialog modal-sm">
          <div class="modal-add-call" tabindex="-1" role="dialog">
            <div role="document">
              <div class="modal-content o-common-modal-content">
                <div class="modal-header u-no-border text-center modal-header--heading">
                  <button type="button" @click="closeOnboard()" class="close custom-modal--close" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                  <h1 class="modal-title">Onboard worker into slot</h1>
                </div>
                <div class="modal-body c-common-box-shadow o-modal-body">
                  <div class="row">
                    <div class="col-sm-12" v-if="onboardModal.call">
                      <div class="call-timings-text">
                        <label class="common-label-text">Slot:</label>
                        <p class="mt-10">{{ onboardSlotLabel }}</p>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label class="common-label-text mb-5p">Onboarding preset</label>
                        <select class="form-control" v-model="onboardModal.profileId">
                          <option disabled value="">— select a preset —</option>
                          <option v-for="p in onboardProfiles" :key="p.id" :value="p.id">
                            {{ p.profile_name }}<span v-if="p.is_default"> (default)</span>
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label class="common-label-text mb-5p">Cell number</label>
                        <input type="text" class="form-control" v-model="onboardModal.phone" placeholder="(555) 123-4567" maxlength="32" />
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <p class="onboard-help">A single-use onboarding link is texted to this number. The worker is seated in this slot as <strong>unconfirmed</strong> now and completes their profile from the link.</p>
                    </div>
                  </div>
                </div>
                <div class="modal-footer text-center">
                  <ul class="o-filter-area">
                    <li>
                      <a href="javascript: void(0)" @click="closeOnboard()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                    </li>
                    <li>
                      <a href="javascript: void(0)" @click="submitOnboard()" :class="{'isDisabled': onboardModal.submitting || !onboardModal.phone || !onboardModal.profileId}" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-user-plus" aria-hidden="true"></i> {{ onboardModal.submitting ? 'Sending…' : 'Onboard & add' }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </modal>

    </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import { mapGetters } from 'vuex';
    import { bus } from '../../main';
    import service from '../../services.js';
    // #1854 — prewarm the assign caches for this job. Fire-and-forget:
    // never awaited, scheduled off the critical path, failures swallowed.
    import { warmJobCache } from '../../warmAssignCache.js';
    import { scroller } from 'vue-scrollto/src/scrollTo';
    import VueJsonToCsv from 'vue-json-to-csv';
    import NotAllowed from '@/components/NotAllowed';

    export default {
        data() {
            const dataProps = {
                auto_fill:true,
                dateGroupAutofill: {},
                isUpdatingGroup: {},
                isEmployeeAllowed: true,
                config: {
                    format: 'h:mm A',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    widgetPositioning: {
                        vertical: 'auto',
                        horizontal: 'right'
                    },
                    parseInputDate: (inputDate) => {
                        if (typeof inputDate === 'string') {
                            const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);
                            if (match) {
                                let hours = parseInt(match[1], 10);
                                let minutes = match[2] ? parseInt(match[2], 10) : 0;
                                return moment({ hour: hours, minute: minutes });
                            }
                        }

                        return moment(inputDate, 'hh:mm A');
                    }

                },
                config2: {
                    allowInputToggle: true,
                    format: 'HH:mm',
                    // Split-duration picker — 0–23h (#1338, IATSE 24 long rest splits)
                    showClear: true,
                    stepping:'00:15',
                    disabledHours: [24],
                    disabledTimeIntervals: [[moment({ h: 23, m: 59 }), moment({ h: 24 })]],
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    widgetPositioning: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    parseInputDate: (inputDate) => {
                        if (typeof inputDate === 'string') {
                            const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);

                            if (match) {
                                let hours = parseInt(match[1], 10);
                                let minutes = match[2] ? parseInt(match[2], 10) : 0;
                                return moment({ hour: hours, minute: minutes });
                            }
                        }
                        return moment(inputDate, 'hh:mm A');
                    }

                },
                timerState:null,
                polling:null,
                unassignedStatusId:'0169fbd1-aec7-4f66-ad42-e318f453d104',
                loading:false,
                callNotes:'',
                selectedFilter: 'none',
                selectedFilterDay: 'noneDay',
                jobStart: null,
                jobEnd: null,
                selectedSortType: '',
                calls: null,
                callsBySorting: [],
                lastDate: '',
                storeMore: [],
                callDaysForJob: [],
                afterAPI: false,
                editCallData: {
                    keep_confirmation: 0,
                    start: '',
                    end: '',
                    notes: '',
                    rate: '',
                    skill_id: '',
                    date: ''
                },
                splitCallData:{
                    end:'',
                    break:'',
                },
                selectedSplitCall:'',
                positions: {},
                status: '',
                callId: '',

                advanceCloneData: {
                    selectedDaysToClone: [],
                    selectedcallsToClone: [],
                    insertMode: 1,
                    assignments: 1,
                    selectedCloneToJob:'',
                    callUnderSelectedDay: [],
                },
                avdCloneJob:[],
                avdCloneCall:[],

                cloneData: {
                    assignments: true,
                    cloneFrom: '',
                    closeTo: '',
                },
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < dataProps.getDates().jobStart || time.getTime() > dataProps.getDates().jobEnd);
                    }
                },
                getDates: function() {
                    return {
                        jobStart: dataProps.jobStart,
                        jobEnd: dataProps.jobEnd
                    };
                },
                selectedJobTitle:'',
                cloneConflictEmployees: [],
                callNotifyType: '',
                // #1511 — blank-row onboarding (immediate-assign) state.
                onboardProfiles: [],
                onboardProfilesLoaded: false,
                onboardModal: {
                    call: null,
                    phone: '',
                    profileId: '',
                    submitting: false,
                },
            };
            return dataProps;
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                jobId: 'selectedJobId',
                userID: 'userID',
                getLastPositionId: 'getLastPositionId',
                getCurrency: 'getCurrency',
                getSelectedCallList: 'getSelectedCallList'
            }),
            isNonEmpty() {
                if (Array.isArray(this.calls)) {
                    return this.calls.length > 0;
                } else if (this.calls && typeof this.calls === 'object') {
                    return Object.keys(this.calls).length > 0;
                }
                return false;
            },
            dateGroupChecked() {
                return (dateKey) => {
                    const calls = this.calls?.[dateKey] || [];
                    return calls.length > 0 && calls.every(call => call.af === true);
                };
            },
            dateGroupIndeterminate() {
                return (dateKey) => {
                    const calls = this.calls?.[dateKey] || [];
                    if (calls.length === 0) return false;
                    const trueCount = calls.filter(call => call.af === true).length;
                    return trueCount > 0 && trueCount < calls.length;
                };
            },
            // #1511 — show the blank-row "Onboard" action when the user has at
            // least one active onboarding preset they can send (mirrors the
            // sideNav "Onboard" menu gate). The precise steward / PU / CA
            // authorization is enforced server-side.
            canOnboard() {
                return Array.isArray(this.onboardProfiles) && this.onboardProfiles.length > 0;
            },
            onboardSlotLabel() {
                const c = this.onboardModal.call;
                if (!c) return '';
                const skill = c.skill && c.skill.name ? c.skill.name : 'Position';
                const start = c.start ? moment(c.start).format('MMM D, h:mm A') : '';
                return start ? `${skill} — ${start}` : skill;
            },
        },

        props: {
            sortType: {
                type: String,
                required: true
            },
            job:{
                type: Object,
                required: true
            }
        },

        watch: {
            async sortType(newData) {
                this.selectedSortType = newData;
                this.sortCalls();
            },
            getSelectedCallList() {
                if(this.getSelectedCallList === 'individual') {
                    this.getAllCalls();
                }
            },
            calls: {
                handler() {
                    Object.keys(this.calls || {}).forEach(dateKey => {
                        this.updateParentGroup(dateKey);
                    });
                },
                deep: true
            }
        },

        methods: {
            checkNotifyGroup() {
                this.callNotifyType = 'group';
                console.log("CheckGroup");
            },
            checkNotifySingle() {
                this.callNotifyType = 'single';
                console.log("CheckSingle");
            },
            getFormattedCallTime() {
                let timeCallFormat = moment(this.selectedSplitCall.start).format('hh:mm a') + " - " + moment(this.selectedSplitCall.end).format('hh:mm a');

                return timeCallFormat;
            },
            changeBreakTime() {
                console.log(this.splitCallData.break);
            },
            setSelectedBreakTime(breakTime) {
                console.log(breakTime);
            },

            getRoundOffSkillSeniority(seniorityVal) {
                if(seniorityVal && seniorityVal != '') {
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },

            getDateScrollTO(str) {
                return moment(str, 'YYYY-MM-DD').format('DD MMM YYYY');
            },

            onSelectScrollTo(e) {
                const firstScrollTo = scroller();
                firstScrollTo(e.target.value, 200, {
                    offset: -100
                });
            },

            addBulkCall(date='') {
                this.$router.push({
					path:'/addCall/'+ this.$route.params.jobId,
                    query: date!=''?{ date: date }: null
				});
            },

            changeSortType() {
                bus.$emit('sortTypeChanged', this.selectedSortType);
            },

            deleteCallsByDate(dateWiseCalls){
                let callIds = [];
                dateWiseCalls.forEach(call =>{
                    callIds.push(call.id);
                });
                this.$confirm('CALL will be removed from the records of CALL LIST and Confirmed Calls Will Be Notified. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('call/deleteBulkCall', {
                        'callIds': JSON.stringify(callIds),
                        'userId':this.userID,
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        this.getAllCalls();
                    }).catch((err) => {
                        console.log(err);
                        this.$notify({
                            type: 'error',
                            message: 'Something Went wrong',
                            title: 'Error'
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },

            getNotes(notes){
                return notes.slice(0,38)+'.. ';
            },

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            // #1511 — load the active onboarding presets this user can
            // send. Drives canOnboard + the preset dropdown. Best-effort: a
            // failure (e.g. no access) just leaves the Onboard action hidden.
            loadOnboardProfiles() {
                if (this.onboardProfilesLoaded) return;
                this.onboardProfilesLoaded = true;
                service.getUrl('/api/v3/onboarding/my-profiles').then((res) => {
                    const list = (res && res.data && res.data.data) ? res.data.data : [];
                    // #1511 — any ACTIVE preset enables the slot-insert; the old
                    // allows_immediate_assign filter hid the feature entirely
                    // until a buried preset switch was flipped (dropped per ed).
                    this.onboardProfiles = list.filter(p => p.active);
                }).catch(() => {
                    this.onboardProfiles = [];
                });
            },

            // #1511 — double-click handler on the Employee cell. Opens the
            // onboard popup only for an UNASSIGNED slot when the user can onboard
            // (has an active preset); otherwise a no-op so double-clicking an
            // already-assigned cell does nothing.
            maybeOnboard(call) {
                if (this.canOnboard && call.status && call.status.name === 'Unassigned') {
                    this.openOnboard(call);
                }
            },

            openOnboard(call) {
                const dflt = this.onboardProfiles.find(p => p.is_default);
                this.onboardModal = {
                    call: call,
                    phone: '',
                    profileId: dflt ? dflt.id : (this.onboardProfiles[0] ? this.onboardProfiles[0].id : ''),
                    submitting: false,
                };
                this.$modal.show('onboard-slot');
            },

            closeOnboard() {
                this.$modal.hide('onboard-slot');
                this.onboardModal = { call: null, phone: '', profileId: '', submitting: false };
            },

            submitOnboard() {
                if (this.onboardModal.submitting) return;
                if (!this.onboardModal.phone || !this.onboardModal.profileId || !this.onboardModal.call) {
                    this.$notify({ type: 'error', title: 'Error', message: 'Enter a cell number and choose a preset.' });
                    return;
                }
                this.onboardModal.submitting = true;
                const payload = {
                    phone: this.onboardModal.phone,
                    profile_id: this.onboardModal.profileId,
                    target_call_id: this.onboardModal.call.id,
                };
                service.postUrl('/api/v3/onboarding/links', payload).then((res) => {
                    const sms = res && res.data && res.data.data && res.data.data.channels
                        ? res.data.data.channels.sms : null;
                    const smsOk = sms && sms.ok;
                    this.$notify({
                        title: 'Success',
                        message: smsOk
                            ? 'Worker added to the slot (unconfirmed). Onboarding text sent.'
                            : 'Worker added to the slot (unconfirmed). The onboarding text could not be sent — resend from the worker record.',
                        type: smsOk ? 'success' : 'warning',
                    });
                    this.closeOnboard();
                    this.getAllCalls();
                }).catch((err) => {
                    const code = err && err.response ? err.response.status : null;
                    const apiErr = err && err.response && err.response.data ? err.response.data.error : null;
                    let message = 'Something went wrong.';
                    if (code === 403 || apiErr === 'forbidden_immediate_assign') {
                        message = 'You are not permitted to onboard workers into a slot (steward, power-user, or client-admin only).';
                    } else if (apiErr === 'phone_validation_failed') {
                        message = 'That cell number could not be validated. Check it and try again.';
                    }
                    this.onboardModal.submitting = false;
                    this.$notify({ type: 'error', title: 'Error', message: message });
                });
            },

            getCurrencyIcon(){
                let icon='';
                switch(this.getCurrency){
                    case 'usd':
                        icon = '$';
                        break;
                    case 'pound':
                        icon = '&#163;';
                        break;
                    default:
                        icon = '$';
                }
                return icon;
            },

            getCurrencyUpper(){
                return this.getCurrency?this.getCurrency.toUpperCase():'USD';
            },

            saveSplitCall(){

                if(this.splitCallData.end=='' || this.splitCallData.break==''){
                    this.$notify({
                        title: 'Error',
                        message: "End time and break time can't be blank.",
                        type: 'error'
                    });
                }else{
                    let splitBreak = this.splitCallData.break.split(':');
                    if(parseInt(splitBreak[0])>23 || (parseInt(splitBreak[0])==23 && splitBreak[1]!='00')) {
                        this.$notify({
                            title: 'Error',
                            message: "Split Duration must be 23 hours or less",
                            type: 'error'
                        });
                        return;
                    }

                    var temp=this.splitCallData.break.split(':').length;
                    var fromData={
                        'end_time': this.selectedSplitCall.start.split(" ")[0]+' '+moment(this.splitCallData.end, 'HH:mm A').format('HH:mm:ss'),
                        'break_duration': this.splitCallData.break,
                    }
                    if(temp!=2)
                        fromData.break_duration=this.splitCallData.break+':00';
                    if (moment(this.selectedSplitCall.start.split(" ")[1], 'HH:mm ss').format('HH:mm:ss') >= moment(this.splitCallData.end, 'HH:mm A').format('HH:mm:ss')) {
                        fromData.end_time=moment(fromData.end_time, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                    }

                    let endBreak = moment(fromData.end_time, 'YYYY-MM-DD HH:mm:ss').add(parseInt(splitBreak[0]),'hours').format('YYYY-MM-DD HH:mm:ss');

                    endBreak = moment(endBreak, 'YYYY-MM-DD HH:mm:ss').add(parseInt(splitBreak[1]),'minutes').format('YYYY-MM-DD HH:mm:ss');

                    if(moment(this.selectedSplitCall.end).isBefore(moment(fromData.end_time))) {
                        this.$notify({
                            title: 'Error',
                            message: "Not a valid split!",
                            type: 'error'
                        });
                        return;
                    }
                    if(moment(this.selectedSplitCall.end).isBefore(moment(endBreak))) {
                        this.$notify({
                            title: 'Error',
                            message: "Not a valid split! Duration is exceeding the call-end",
                            type: 'error'
                        });
                        return;
                    }
                    
                    this.$Progress.start();
                    service.post('call/'+this.selectedSplitCall.id+'/splitCalls', fromData, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        this.$Progress.finish();
                        this.afterAPI = true;
                        this.$modal.hide("split-call");
                        this.splitCallData.break = '';
                        this.splitCallData.end = '';
                        this.$notify({
                            title: 'Success',
                            message: 'Call Splited Successfully.',
                            type: 'success'
                        });
                        this.getAllCalls();
                    }).catch((err) => {
                        this.afterAPI = true;
                        console.log(err);
                        this.$Progress.finish();
                    });
                }
            },

            openSplitCall(call){
                console.log(call);
                this.selectedSplitCall=call;
                this.$modal.show("split-call");
            },

            hideSplitCall(){
                this.$modal.hide("split-call");
            },

            async sortCalls() {
                let self = this;
                switch (this.selectedSortType) {
                    case 'start':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                var dateA = moment(a.start);
                                var dateB = moment(b.start);
                                return dateA > dateB ? 1 : -1;
                            });
                        }
                        break;
                    case 'status':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                if (a.status.name == "Unassigned") return -1;
                                if (a.status.name == 'Unconfirmed' || a.status.name == 'Confirmed' || b.status.name == 'Unconfirmed' || b.status.name == 'Confirmed') return 1;
                                return 0;
                            });
                        }
                        break;
                    case 'skill':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                if (a.skill.priotiy < b.skill.priotiy) return -1;
                                if (a.skill.priotiy > b.skill.priotiy) return 1;
                                return 0;
                            });
                        }
                        break;
                    case 'seniority':
                        for (let key in this.callsBySorting) {
                            this.callsBySorting[key].sort(function(a, b) {
                                if (a.status.name == "Unassigned") return 1;
                                if (a.status.name == 'Unconfirmed' || a.status.name == 'Confirmed' || b.status.name == 'Unconfirmed' || b.status.name == 'Confirmed') return -1;
                                return 0;
                            });
                        }
                        let calls = this.callsBySorting;
                        for (let key in calls) {
                            calls[key].forEach((item) => {
                                if((item.employee && !item.employee.seniority)||(item.employee && item.employee.seniority == '')) {
                                    item.employee.seniority = 0;
                                }else {
                                    if(item.employee){
                                        item.employee.seniority = parseFloat(item.employee.seniority);
                                    }
                                }
                            });
                        }

                        for (let key in calls) {
                            calls[key].sort((a, b) => {
                                if(a.status.name == 'Unassigned' || b.status.name == 'Unassigned') {
                                    return -1;
                                } else if(a.employee && b.employee) {
                                    if(a.employee && a.employee["seniority"]>=0 && b.employee && b.employee["seniority"]>=0) {
                                        if (parseFloat(a.employee.seniority) > parseFloat(b.employee.seniority)) return 1;
                                        if (parseFloat(a.employee.seniority) < parseFloat(b.employee.seniority)) return -1;
                                        if (a.employee.seniority == b.employee.seniority) {
                                            if(a.employee.employable && a.employee.employable.last_name && b.employee.employable && b.employee.employable.last_name) {
                                                var nameA = a.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                                var nameB = b.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                                if (nameA < nameB) {
                                                    return -1;
                                                }
                                                if (nameA > nameB) {
                                                    return 1;
                                                }
                                            }
                                        }
                                    } else {
                                        if(a.employee.employable && a.employee.employable.last_name && b.employee.employable && b.employee.employable.last_name) {
                                            var nameA = a.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                            var nameB = b.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                            if (nameA < nameB) {
                                                return -1;
                                            }
                                            if (nameA > nameB) {
                                                return 1;
                                            }
                                        }
                                    }
                                } else {
                                    return -1;
                                }
                                return 0;
                            });
                        }
                        this.calls = calls;
                        break;
                    default:
                        //console.log("default case..");
                }
            },

            editCalls(call,id) {
                this.$store.dispatch('setLastPositionId', id);
                this.$modal.show("edit-call");
                this.getPositions();
                this.editCallData.keep_confirmation = 0;
                this.editCallData.start = moment(call.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm A');
                this.editCallData.end = moment(call.end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm A');
                this.editCallData.notes = call.notes;
                this.editCallData.rate = call.rate;
                this.status = call.status&&call.status.name&&call.status.name ? call.status.name : "";
                this.editCallData.skill_id = call.skill.id;
                var tempDate = call.called_at.split(" ");
                this.editCallData.date = tempDate[0];
                this.callId = call.id;
            },

            deleteCall(call,id) {
                this.$store.dispatch('setLastPositionId', id);
                this.$confirm('CALL will be removed from the records of CALL LIST. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('call/deleteCall', {
                            'call_id': call.id,
                            'user_id': this.userID,
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            this.$message({
                                type: 'success',
                                message: 'Delete completed'
                            });
                            this.getAllCalls();
                        }).catch((err) => {
                            console.log(err);
                            this.$notify({
                                type: 'error',
                                message: 'Something Went wrong',
                                title: 'Error'
                            });
                        });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },

            saveEditCall() {
                let editCallFormData = {
                    keep_confirmation: this.editCallData.keep_confirmation == '1' ? 1 : 0,
                    start: this.editCallData.date + " " + moment(this.editCallData.start, 'HH:mm A').format('HH:mm:ss'),
                    end: this.editCallData.date + " " + moment(this.editCallData.end, 'HH:mm A').format('HH:mm:ss'),
                    rate: this.editCallData.rate,
                    call_id: this.callId,
                    notes: this.editCallData.notes,
                    skill_id: this.editCallData.skill_id,
                    user_id: this.userID
                };

                if (moment(this.editCallData.start, 'HH:mm A').format('HH:mm:ss')>=moment(this.editCallData.end, 'HH:mm A').format('HH:mm:ss')) {
                    editCallFormData.end=moment(editCallFormData.end, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                }
                this.$Progress.start();
                service.post('call/updateAParticularCall', editCallFormData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.afterAPI = true;
                    if(res.data.status_code==0){
                      this.$modal.hide("edit-call");
                      this.$notify({
                          title: 'Success',
                          message: 'Call Updated Successfully.',
                          type: 'success'
                      });
                      this.getAllCalls();
                    }else{
                      this.$notify({
                        title: 'Error',
                        message: res.data.status_message,
                        type: 'error'
                      });
                    }
                }).catch((err) => {
                    this.afterAPI = true;
                    console.log('error_message',err);
                    this.$notify({
                        title: 'Error',
                        message: 'Something went wrong.',
                        type: 'error'
                    });
                });
                //console.log(temp);
            },

            closeEditCalls() {
                this.$modal.hide("edit-call");
            },

            singleAssign(call, id) {
                this.$store.dispatch('setCall', call);
                this.$store.dispatch('setLastPositionId', id);
                this.$router.push({
                    path: `/singleAssignCustom/` + this.$route.params.jobId
                });
            },

            cleaeAssign(call,id) {
                this.$store.dispatch('setLastPositionId', id);
                this.$confirm('Are you sure you would like to clear this Call?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
              }).then(() => {
                service.del('call/' + call.id + '/assign', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userId': this.userID,

                }).
                then((res) => {
                    this.$notify({
                        title: 'Success',
                        message: 'Call cleared successfully.',
                        type: 'success'
                    });
                    this.getAllCalls();
                }).catch((err) => {
                    console.log(err);
                    this.$notify({
                        type: 'error',
                        message: 'Something went wrong.',
                        title: 'Error'
                    });
                });
              }).catch(() => {
                  this.$message({
                      type: 'info',
                      message: 'Clear canceled'
                  });
              });
            },

            async handleScroll(position) {               
                if (position !== "bottom") return; 
                await this.loadMore();
            },


            async loadMore() {
                if (this.storeMore.length != 0) {
                    this.calls = Object.assign({}, this.calls, this.storeMore);
                    this.callsBySorting = Object.assign({}, this.callsBySorting, this.storeMore);
                    bus.$emit('onUpdateCallList', this.calls);
                    this.storeMore = [];
                    if (this.lastDate != '') {
                        await service.get('job/' + atob(this.$route.params.jobId) + '/callCalendar', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'nextDate': this.lastDate,
                            })
                            .then((res) => {
                                this.storeMore = res.data.result;
                                if (this.storeMore.length != 0) {
                                    this.lastDate = Object.keys(this.storeMore)[Object.keys(this.storeMore).length - 1] + " " + Date().slice(16, 24);
                                } else {
                                    this.lastDate = '';
                                }
                            }).catch((err) => {
                                console.log(err);
                            })
                    } else {
                        this.storeMore = [];
                    }
                    this.$nextTick(() => {
                        if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                            this.$refs.scrollContainer._checkScroll();
                        }
                    });
                }
            },

            async getAllCalls() {
                this.$Progress.start();
                this.calls =[];
                this.callsBySorting = [];
                let scrollPositionX = window.pageXOffset;
                let scrollPositionY = window.pageYOffset;
                this.loading=true;
                await service.get('job/' + atob(this.$route.params.jobId) + '/callCalendar', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then(async(res) => {
                        this.loading=false;
                        this.$Progress.finish();
                        this.afterAPI = true;
                        this.calls = res.data.result;
                        this.callsBySorting = res.data.result;
                        bus.$emit('onUpdateCallList', this.calls);
                        this.sortCalls();
                        this.initDateGroupAutofill();
                        const firstScrollTo = scroller();
                        if(this.getLastPositionId && this.getLastPositionId !=''){
                            let self=this;
                            setTimeout(() => {
                                var positionID='#'+self.getLastPositionId;
                                firstScrollTo(positionID, 200, {
                                    offset: -150
                                });
                                self.$store.dispatch('setLastPositionId', '');
                            }, 300);
                        }
                        else {
                            window.scrollTo(scrollPositionX, scrollPositionY);
                            document.body.scrollPositionY;
                        }
                    }).catch((err) => {
                        console.log(err);
                        this.afterAPI = true;
                        this.loading=false;
                        this.$Progress.finish();
                        if(err.response&&err.response.status&&err.response.status==403) {
                            this.isEmployeeAllowed = false;
                            bus.$emit('onOptionsNotAllowed', this.isEmployeeAllowed);
                            this.$notify({
                                title: 'Important message',
                                message: "You don't have Access!",
                                type: 'error'
                            });
                            this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                        }
                    });

                window.scroll();
                $( "#individualCallSplit" ).scroll();
            },

            async refreshCalls() {
                if(this.getSelectedCallList == 'individual') {
                    this.$Progress.start();
                    let scrollPositionX = window.pageXOffset;
                    let scrollPositionY = window.pageYOffset;
                    this.callsBySorting = [];

                    await service.get('job/' + atob(this.$route.params.jobId) + '/callCalendar', {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then(async(res) => {
                            this.$Progress.finish();
                            this.afterAPI = true;
                            this.calls = [];
                            this.loading=true;
                            setTimeout(() => {
                                this.loading=false;
                            }, 200);
                            this.calls = res.data.result;
                            this.callsBySorting = res.data.result;
                            bus.$emit('onUpdateCallList', this.calls);
                            this.sortCalls();
                            this.initDateGroupAutofill();
                            const firstScrollTo = scroller();
                            if(this.getLastPositionId && this.getLastPositionId !=''){
                                let self=this;
                                setTimeout(() => {
                                    var positionID='#'+self.getLastPositionId;
                                    firstScrollTo(positionID, 200, {
                                        offset: -150
                                    });
                                    self.$store.dispatch('setLastPositionId', '');
                                }, 300);
                            }
                            else {
                                window.scrollTo(scrollPositionX, scrollPositionY);
                                document.body.scrollPositionY;
                            }
                            this.$forceUpdate();
                        }).catch((err) => {
                            console.log(err);
                            this.afterAPI = true;
                            this.loading=false;
                            this.$Progress.finish();
                        });
                }
            },

            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },

            getDate(dateTime) {
                return dateTimeConvert.localDateFull(dateTime);
            },

            getGlobalDate(dateTime) {
                return dateTimeConvert.localDate(dateTime);
            },

            getPositions() {
                this.$Progress.start();
                service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.positions = res.data.result;
                    this.$Progress.finish();
                    this.afterAPI = true;
                }).catch((err) => {
                    this.afterAPI = true;
                    console.log(err);
                });
            },

            openCloneModal(cloneFrom) {
                this.cloneConflictEmployees = [];
                this.$modal.show("call-clone");
                this.cloneData.cloneFrom = cloneFrom.split(" ")[0];
                this.$Progress.start();
                service.get('call/callDaysForJob', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'job-id': atob(this.$route.params.jobId),
                    })
                    .then((res) => {
                        this.callDaysForJob = res.data.result;
                        this.cloneData.closeTo = this.callDaysForJob[0].date;
                        this.$Progress.finish();
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
            },

            cloneCall() {
                let fromData = {
                    from: this.cloneData.cloneFrom + " " + this.calls[this.cloneData.cloneFrom][0].called_at.split(' ')[1],
                    to: this.cloneData.closeTo,
                    job_id: atob(this.$route.params.jobId),
                    assign: (this.cloneData.assignments) ? 1 : 0,
                    user_id: this.userID
                };
                service.post('call/clone', fromData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        this.$modal.hide("call-clone");
                        if(res.data.result && res.data.result.length) {
                            this.cloneConflictEmployees = res.data.result;
                            this.cloneConflictEmployees.forEach((obj) => {
                                obj.conflict_type = obj.conflict_type=='RU' ? 'Recurring Unavailability'
                                                    : obj.conflict_type=='booking' && obj.job_no!="" ? 'Booking'
                                                    : (obj.conflict_type=='booking' && obj.job_no == "") || (obj.conflict_type=='vacation') ? 'Vacation'
                                                    : obj.conflict_type;
                                obj.date = moment(this.cloneData.closeTo).format('MM/DD/YYYY')
                            });
                            this.$modal.show("clone-conflict-employee-modal");
                        }
                        this.$notify({
                            title: 'Success',
                            message: 'Call Clone Successfully.',
                            type: 'success'
                        });
                        this.getAllCalls();
                    }).catch((err) => {
                        console.log(err);
                    });
            },

            closeCloneModal() {
                this.$modal.hide("call-clone");
            },

            openAdvanceClone(selectedCloneTo) {
                this.cloneConflictEmployees = [];
                this.$Progress.start();
                this.advanceCloneData.selectedcallsToClone=[];
                service.get('call/callDaysForJob', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'job-id': atob(this.$route.params.jobId),
                })
                .then((res) => {
                    this.callDaysForJob = res.data.result;
                    for (let i = 0; i < this.callDaysForJob.length; i++) {
                        if (this.callDaysForJob[i].calls.length > 0) {
                            if (this.callDaysForJob[i].date.split(" ")[0] == selectedCloneTo) {
                                this.advanceCloneData.callUnderSelectedDay = this.callDaysForJob[i].calls;
                            }
                        }
                    }
                    this.$Progress.finish();
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                });

                this.$Progress.start();
                service.get('job/jobsListing', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.advanceCloneData.selectedCloneToJob=atob(this.$route.params.jobId);
                    this.getJobCalls();
                    this.avdCloneJob=res.data.result;
                    console.log(res);
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                });
                this.$modal.show("advance-call-clone");
            },

            getJobCalls(){
                this.advanceCloneData.selectedDaysToClone=[];
                this.selectedFilterDay = 'noneDay';
                this.$Progress.start();
                    service.get('call/jobCallsListing', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'job-id': this.advanceCloneData.selectedCloneToJob,
                    })
                    .then((res) => {
                        this.$Progress.finish();
                        this.avdCloneCall=res.data.result;
                        console.log(res);
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
            },

            closeAdvanceClone() {
                this.$modal.hide("advance-call-clone");
            },

            selectAllDay() {
                this.selectedFilterDay = 'allDay';
                let self = this;
                this.avdCloneCall.forEach(function(call) {
                    self.advanceCloneData.selectedDaysToClone.push(call.date);
                });
            },

            selectNoneAllDay() {
                this.selectedFilterDay = 'noneDay';
                this.advanceCloneData.selectedDaysToClone = [];
            },

            selectAllCall() {
                this.selectedFilter = 'all';
                let self = this;
                this.advanceCloneData.callUnderSelectedDay.forEach(function(call) {
                    self.advanceCloneData.selectedcallsToClone.push(call.id);
                });
            },

            selectNoneAllCall() {
                this.selectedFilter = 'none';
                this.advanceCloneData.selectedcallsToClone = [];
            },

            saveAdvanceClone() {
                let fromData = {
                    call_ids: JSON.stringify(this.advanceCloneData.selectedcallsToClone),
                    clone_to_dates: JSON.stringify(this.advanceCloneData.selectedDaysToClone),
                    insert_mode: this.advanceCloneData.insertMode,
                    assign: this.advanceCloneData.assignments,
                    job_id: this.advanceCloneData.selectedCloneToJob,
                    user_id: this.userID
                };
                service.post('call/advanceCall', fromData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).then((res) => {
                    if(res.data.result && res.data.result.length) {
                        this.cloneConflictEmployees = res.data.result;
                        this.$modal.show("clone-conflict-employee-modal");
                    }
                    this.$notify({
                        title: 'Success',
                        message: 'Call Clone Successfully.',
                        type: 'success'
                    });
                    this.getAllCalls();
                    this.$modal.hide("advance-call-clone");
                }).catch((err) => {
                    console.log(err);
                });
            },

            pollData () {
                this.polling = setInterval(() => {
                        if(document.visibilityState === 'visible'){
                            this.timerState = "Started"
                        }else {
                            this.timerState = "Paused"
                        }
                    if (this.timerState === "Started") {
                        this.refreshCalls();
                    }
                }, 60000);
            },

            closeCloneConflictEmployeeModal() {
                this.$modal.hide("clone-conflict-employee-modal");
                this.cloneConflictEmployees = [];
            },

            copyText(){
                let data1 = [];

                this.cloneConflictEmployees.forEach((obj) => {
                    let tempObj = {
                        'Name': obj.emp_name,
                        'Date': obj.date,
                        'Conflict': obj.conflict_type,
                        'Job Name': obj.job_title,
                        'Job Number': obj.job_no
                    }
                    data1.push(tempObj);
                })

                const items = data1;
                const replacer = (key, value) => value === null ? '' : value;
                const header = Object.keys(items[0]);
                const csv = [
                header.join(','),
                ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
                ].join('\r\n');

                console.log(csv);
                var textarea = document.createElement("textarea");
		        textarea.textContent = csv;
		        textarea.style.position = "fixed"; 
		        document.body.appendChild(textarea);
		        textarea.select();
		        try {
		        	document.execCommand("copy");
		            this.$notify({
                        title: 'Success',
                        message: 'Copied to clipboard.',
                        type: 'success'
                    });

		        } catch (ex) {
		            console.warn("Copy to clipboard failed.", ex);
		            return false;
		        } finally {
		            document.body.removeChild(textarea);
		        }
            },

            handleCsvSuccess(msg) {
                console.log(msg);
            },

            handleCsvError(error) {
                console.log(error);
            },

            getDateKey(call) {
                if (!call || !call.calledat) return '';
                try {
                    return call.calledat.split(',')[0];
                } catch (e) {
                    console.warn('Failed to parse calledat:', call.calledat);
                    return '';
                }
            },


            async handleIndividualAutofillChange(call) {
                if (!call || !call.id) {
                    console.error('Invalid call object:', call);
                    return;
                }

                const dateKey = this.getDateKey(call);
                if (this.isUpdatingGroup[dateKey]) return;

                const payload = [{ 
                    call_id: call.id, 
                    status: call.af
                }];

                this.$Progress.start();
                
                try {
                    await service.post('/call/autofillselections', payload, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    });
                    
                    this.$notify({
                        title: 'Success', 
                        message: 'Auto-fill updated successfully', 
                        type: 'success' 
                    });
                    
                    // Update parent group checkbox state
                    if (dateKey) {
                        this.updateParentGroup(dateKey);
                    }
                    
                } catch (err) {
                    console.error('Autofill update failed:', err);
                    // Revert checkbox on error
                    call.af = !call.af;
                    this.$notify({
                        title: 'Error', 
                        message: 'Failed to update auto-fill', 
                        type: 'error' 
                    });
                } finally {
                    this.$Progress.finish();
                }
            },

            async handleGroupAutofillChange(dateKey, checked) {
                const calls = this.calls?.[dateKey] || [];
                if (calls.length === 0) return;

                this.$set(this.isUpdatingGroup, dateKey, true);
                const callIds = calls.map(call => call.id);
                const value = checked;
                const payload = callIds.map(id => ({ call_id: id, status: value }));

                try {
                    await service.post('/call/autofillselections', payload, {
                    Authorization: this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                    });
                    // Update local state
                    calls.forEach(call => (call.af = value));
                    this.$set(this.dateGroupAutofill, dateKey, value);
                    this.$notify({ title: 'Success', message: `Group auto-fill updated for ${this.getDate(dateKey)}`, type: 'success' });
                } catch (err) {
                    console.error(err);
                    this.$set(this.dateGroupAutofill, dateKey, !value);  // Revert
                    this.$notify({ title: 'Error', message: 'Group update failed', type: 'error' });
                } finally {
                    this.$set(this.isUpdatingGroup, dateKey, false);
                }
            },

            updateParentGroup(dateKey) {
                // Called after individual change to sync group checkbox
                const allChecked = this.dateGroupChecked(dateKey);
                this.$set(this.dateGroupAutofill, dateKey, allChecked);
            },

            initDateGroupAutofill() {
                Object.keys(this.calls || {}).forEach(key => {
                    const calls = this.calls[key] || [];
                    const allChecked = calls.length > 0 && calls.every(call => call.af === true);
                    this.$set(this.dateGroupAutofill, key, allChecked);
                });
            }
        },

        components: {
            VueJsonToCsv,
            NotAllowed
        },

        beforeMount() {
            window.scroll();
            $( "#individualCallSplit" ).scroll();
        },

        mounted() {
            this.selectedJobTitle = this.job?this.job.title:'';
            $(this.$el).find('input').datetimepicker(this.config)
            .on('dp.show', (e) => {
                const picker = e.target;
                const currentTime = moment();
                if (!picker.value) {
                    $(picker).data('DateTimePicker').date(currentTime);
                }
            });
            $(this.$el).find('input').datetimepicker(this.config2)
            .on('dp.show', (e) => {// Reference to the picker element
                const currentTime = moment();
                if (!picker.value) {
                    $(picker).data('DateTimePicker').date(currentTime);
                }
            });
        },
        created() {
            // #1854 — get a jump on the assign caches for this job. Fires in the
            // background and is never awaited, so it cannot delay this page.
            try {
                warmJobCache(atob(this.$route.params.jobId), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                });
            } catch (e) { /* never blocks the page */ }

            bus.$emit('onOptionsNotAllowed', this.isEmployeeAllowed);
            this.jobStart = new Date(this.job.start);
            this.jobStart.setDate(this.jobStart.getDate() - 1);
            this.jobEnd = new Date(this.job.end);
            this.selectedSortType = this.sortType;
            this.getAllCalls();
            this.loadOnboardProfiles();

            bus.$on('onSaveNewCall', (data) => {
                this.getAllCalls();
            });
            this.pollData();
        },
         beforeDestroy () {
            clearInterval(this.polling)
        }
    }
</script>
<style scoped>
    /* #1511 — onboard-into-slot modal helper text */
    .onboard-help{
        margin-top: 8px;
        font-size: 12px;
        color: #6b7280;
        line-height: 1.5;
    }
    /* #1511 — empty Employee cell is double-clickable to onboard */
    .onboard-dblclick-hint{
        cursor: pointer;
    }
    .mt-10{
        margin-top: 10px;
    }
    .mb-5p{
        margin-bottom: 5px;
    }
    .call-timings-text {
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .allign-right{
        text-align: right;
    }
    .individualCallSplit {
        overflow-y: scroll!important;
        scroll-behavior: smooth;
    }

    .float-right {
        float: right;
    }

    .empty-list {
        height: 60px;
    }
    .o-custom-drop-time{
        padding-top: 19px;
        padding-right: 15px;
    }
    .confirm-check-icon-style{
        background-color: green;
        border-radius: 100%;
        color: white;
        padding: 2px;
    }
    .text-danger{
        color: red !important;
    }
</style>
